<template>
  <div class="organization-position-right-select">
    <div class="organization-position-right-button">
      <a-button type="primary" @click="() => handleAdd(false)">
        {{ $t('page_organization_add_post') }}
      </a-button>
      <a-button type="danger" style="width: 88px" @click="handleDelete">
        {{ $t('delete') }}
      </a-button>
      <a-button @click="() => handleAdd(true)">
        {{ $t('page_organization_edit_post') }}
      </a-button>
    </div>
    <div class="organization-position-right-tree" :class="lang==='en_US' ? 'en':''">
      <template v-for="(item, index) in positionList">
        <div
          class="position-item"
          :class="index === selectIndex ? 'position-item-active' : 'position-item'"
          @click="() => selectPosition(item, index)"
          :key="index"
        >
          <div class="position-item-name">
            {{ item.postName }}
          </div>
          <!-- <div class="position-item-subname">
            {{ item.categoryName }}
          </div> -->
        </div>
      </template>
    </div>
    <add-edit-position
      :visible="addVisible"
      @cancel="cancelAdd"
      :editItem="editItem"
      :isEdit="isEdit"
      @save="saveAdd"
    ></add-edit-position>
  </div>
</template>

<script>
import AddEditPosition from './AddEditPosition.vue'
import { PostServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { getLocalStorage } from '@/utils/storage'
import { getLocalLanguage } from "@/utils";

const psp = new PostServiceProxy()

export default {
  components: {
    AddEditPosition
  },
  data() {
    return {
      addVisible: false,
      positionList: [],
      selectIndex: undefined,
      editItem: {},
      isEdit: false,
      lang: getLocalLanguage('')
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const userInfo = getLocalStorage('USER_INFO')
      const { data } = await psp.list(
        '',
        '',
        '',
        '',
        1,
        '',
        0,
        '',
        '',
        '',
        -1,
        '',
        '',
        userInfo.tenant_id,
        '',
        ''
      )
      this.positionList = data.records
      if (data.records && this.selectIndex === undefined) {
        this.selectPosition(this.positionList[0], 0)
      }
    },
    handleAdd(bool) {
      this.isEdit = bool
      this.addVisible = true
    },
    cancelAdd() {
      this.addVisible = false
    },
    saveAdd() {
      this.getData()
      this.addVisible = false
    },
    selectPosition(item, index) {
      if (this.selectIndex === index) {
        return
      }
      this.editItem = item
      this.selectIndex = index
      this.$emit('changePosition', item)
    },
    handleDelete() {
      this.$confirm({
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        title: this.$t('page_organization_delete_post'),
        content: this.$t('delete_tips') + '?',
        onOk: () => {
          psp.remove(this.editItem.id).then(() => {
            this.selectIndex = undefined
            this.editItem = {}
            this.$message.success(this.$t('delete_success'))
            this.getData()
          })
        },
        class: 'test'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.organization-position-right-select {
  height: calc(100% - 46px);
  padding: 8px 6px;
  .organization-position-right-button {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    button {
      margin-bottom: 8px;
    }
  }
  .organization-position-right-tree {
    height: calc(100% - 40px);
    border: 1px solid #d7d7d7;
    overflow-y: auto;
    overflow-x: hidden;

    &.en {
      height: calc(100% - 80px);
    }
  }
  .position-item {
    padding: 8px 32px;
    .position-item-name {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
    .position-item-subname {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.25);
      line-height: 22px;
    }
  }
  .position-item-active {
    padding: 8px 32px;
    background-color: #4a90e2;
    .position-item-name {
      font-size: 16px;
      color: #fff;
      line-height: 24px;
    }
    .position-item-subname {
      font-size: 14px;
      color: #fff;
      line-height: 22px;
    }
  }
}
</style>
